export var ConversationVisibilityApi;
(function (ConversationVisibilityApi) {
    ConversationVisibilityApi["PUBLIC"] = "PUBLIC";
    ConversationVisibilityApi["PRIVATE"] = "PRIVATE";
})(ConversationVisibilityApi || (ConversationVisibilityApi = {}));
//# sourceMappingURL=conversation-visibility-api.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/end-points-dto/api-dto/chat/conversation-visibility-api.js
// module id = 875
// module chunks = 14